import {defineAction} from 'redux-define';
import {createAction} from 'redux-actions';
import {put, takeLatest} from 'redux-saga/effects';
import {logout} from 'flows/session/reducer';

const namespace = 'flows/interest/confirmed';

// Actions
const LOAD_INTEREST_CONFIRMED = defineAction('LOAD_INTEREST_CONFIRMED', namespace);
export const loadInterestConfirmed = createAction(LOAD_INTEREST_CONFIRMED.ACTION);

// Interest Confirm Saga
export function* interestConfirmedSaga() {
  // Trigger logout
  yield put(logout());
}

export function* sagas() {
  yield takeLatest(LOAD_INTEREST_CONFIRMED.ACTION, interestConfirmedSaga);
}



// WEBPACK FOOTER //
// ./mobile/shared/flows/interest/confirmed/index.js